<template>
  <div>
    <el-dialog :title="'Observatii deviz #' + this.idDeviz" :visible.sync="showPopup" id="popup_dialog"
      class="my-dialog-class" width="50%">
      <el-form label-position="top" :inline="false" :rules="rules" label-width="100%" ref="my-form"
        :model="selectedObject" @submit.prevent="save">
        <el-row>
          <el-col :span="16">
            <el-form-item label="Observatie" prop="Observatie">
              <el-input v-model="selectedObject.Observatie" clearable size="mini" style="width: 100%" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="Observatii prestabilite">
              <el-checkbox-group @change="selectObservatieHandler" style="width: 100%"
                v-model="selectedObject.CheckedObsArr" size="mini">
                <el-checkbox style="width: 100%" v-for="obs in Info.Observatii" :key="obs.observatie"
                  :label="obs.observatie" border />
              </el-checkbox-group>
              <div v-for="obs in observatiiPredefiniteDetaliate" :key="obs.observatiePredefinita"
                style="margin-top: 5px; margin-left: 10px;">
                <strong>{{ obs.observatiePredefinita }}</strong>
                <ul style="margin: 0; padding-left: 20px;">
                  <li v-for="(roata, index) in obs.roti" :key="index">
                    Roata {{ roata.index + 1 }}: cantitate - {{ roata.qty }}
                  </li>
                </ul>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="idProgramare != -1 && optiuneCantitati == 'sursa_destinatie'" label-position="top" :gutter="15" v-loading="loading">
          <el-card>
            <template #header>
              <div>
                <span>Destinatie anvelope </span>
              </div>
            </template>
            <el-form >
              <el-row :gutter="15">
                <el-col :md="6">
                  <el-form-item label="Cantitate totala anvelope">
                    <el-input-number disabled style="width:100%" :min="0" v-model="cantitate" />
                  </el-form-item>
                </el-col>
                <el-col :md="6">
                  <el-form-item label="Reciclare">
                    <el-input-number style="width:100%" :min="0" v-model="Reconditionare" />
                  </el-form-item>
                </el-col>
                <el-col :md="6">
                  <el-form-item label="Hotel">
                    <el-input-number style="width:100%" :min="0" v-model="Hotel" />
                  </el-form-item>
                </el-col>
                <el-col :md="6">
                  <el-form-item label="Returnare">
                    <el-input-number style="width:100%" :min="0" v-model="Returnare" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-card>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPopup = false">Renunta</el-button>
        <el-button type="primary" @click="save">Salveaza</el-button>
      </span>
    </el-dialog>

    <Observatii_devize_dialog ref="observatii_devize" @saveObsDialog="saveObsDialog" @closeObsDialog="closeObsDialog" />
  </div>
</template>

<script>
import BasePage from "@/pages/Admin/BasePage";
import Observatii_devize_dialog from "./Observatii_devize_dialog.vue";
export default {
  name: "Devize_de_aprobat_dialog",
  extends: BasePage,
  components: {
    Observatii_devize_dialog,
  },
  data() {
    return {
      showPopup: false,
      selectedObject: {
        Observatie: "",
        CheckedObsArr: [],
      },
      rules: {
        Observatie: [{ required: false, message: "Campul este obligatoriu" }],
      },

      Info: {
        Observatii: [],
      },
      Returnare: 0,
      Reconditionare: 0,
      Hotel: 0,
      idDeviz: "",
      idProgrmare: null,
      cantitate: null,
      observatiiPredefiniteDetaliate: [],
      cantitateTotalaAnvelope: 0,
      idProgramare: -1,
      loading:false,
      optiuneCantitati: '',
    };
  },
  methods: {
    async show_me(idDeviz, observatii, cantitate, observatiiMecanic, idProgramare) {
      try {
        this.showPopup = true;
        this.idDeviz = idDeviz;
        this.selectedObject.Observatie = "";
        this.selectedObject.CheckedObsArr = [];
        this.Info.Observatii = observatii;
        this.cantitate = cantitate;
        this.observatiiPredefiniteDetaliate = [];
        this.idProgramare = idProgramare

        this.Hotel = 0;
        this.Reconditionare = 0;
        this.Returnare = 0;


        const observatiiMecanicParsed = JSON.parse(observatiiMecanic);
        if (observatiiMecanicParsed && Array.isArray(observatiiMecanicParsed)) {
          observatiiMecanicParsed.forEach((item) => {
            if (item.observatie) {
              this.selectedObject.Observatie = item.observatie;
            }

            if (item.observatiiPreselectate) {
              item.observatiiPreselectate.forEach((obs) => {
                this.selectedObject.CheckedObsArr.push(obs.observatiePredefinita);
                this.observatiiPredefiniteDetaliate.push(obs);
              });
            }
          });
        }

        if (this.idProgramare != -1) {
          this.optiuneCantitati = '';
          const response_optiune = await this.post("receptie/devize/get_serviciu_deviz", { IdProgramare: this.idProgramare });
          if(response_optiune && response_optiune.serviciu && response_optiune.serviciu.length) {
            this.optiuneCantitati = response_optiune.serviciu[0].OptiuneCantitati;
            this.loading = true;
            if(this.optiuneCantitati == 'sursa_destinatie') {
              const response = await this.post("receptie/devize/get_destinatie_anvelope", { IdProgramare: this.idProgramare });
              if (Array.isArray(response.destinatie_anvelope) && response.destinatie_anvelope.length > 0) {
                const destinatie = response.destinatie_anvelope[0];

                this.Reconditionare = parseInt(destinatie.Reconditionare) || 0;
                this.Hotel = parseInt(destinatie.Hotel) || 0;
                this.Returnare = parseInt(destinatie.Returnare) || 0;
              }
            }
          }

          this.loading = false;

        }
      } catch (error) {
        console.error(error);
      }
    },

    prepareDestinatieAnvelope() {
      return {
        Reconditionare: this.Reconditionare,
        Hotel: this.Hotel,
        Returnare: this.Returnare,
      }
    },
    validateDestinatieAnvelope() {
      if (this.optiuneCantitati == 'sursa_destinatie') {
        if (this.cantitate != this.Hotel + this.Reconditionare + this.Returnare) {
          this.$message({ type: 'error', message: 'Cantitatea nu corespunde cu totalul cantitatilor introduse in destinatia anvelopelor!' });
          return false;
        }
      }
      return true;
    },
    async save() {
      if (!this.validateDestinatieAnvelope()) {
        return;
      }
      const is_montaj_senzori = await this.getProduseMontajSenzori();
      this.$refs["my-form"].validate(async (valid) => {
        if (!valid) return;

        if (is_montaj_senzori) {
          try {
            await this.$confirm(
              'Devizul conține produsul "Montaj senzori". Continuați?',
              'Atenție',
              {
                confirmButtonText: 'Da',
                cancelButtonText: 'Nu',
                type: 'warning',
              }
            );
          } catch {
            this.$message({
              type: "info",
              message: "Aprobarea a fost anulată."
            });
            return;
          }
        }

        if (
          this.selectedObject.CheckedObsArr.length === 0 &&
          this.selectedObject.Observatie === ""
        ) {
          this.showPopup = false;
          this.$confirm(
            "Sunteți sigur că vreți să aprobați devizul fără a introduce observații?",
            "Warning",
            {
              confirmButtonText: "Aproba",
              cancelButtonText: "Renunță",
              type: "warning",
            }
          )
            .then(() => {
            const destinatieAnvelope = this.prepareDestinatieAnvelope();
              this.$emit(
                "aprobaDevizHandler",
                false,
                this.idDeviz,
                this.selectedObject.Observatie,
                this.selectedObject.CheckedObsArr,
                destinatieAnvelope,
                is_montaj_senzori
              );
            })
            .catch(() => {
              this.$message({
                type: "warning",
                message: "Devizul nu a fost aprobat!",
              });
            });
        } else {
          const destinatieAnvelope = this.prepareDestinatieAnvelope();

          this.$emit(
            "aprobaDevizHandler",
            true,
            this.idDeviz,
            this.selectedObject.Observatie,
            this.observatiiPredefiniteDetaliate,
            destinatieAnvelope,
            is_montaj_senzori
          );
        }

        this.showPopup = false;
      });
    },

    async getProduseMontajSenzori(){
      const response = await this.post("receptie/devize/get_produse_montaj_senzori", { IdDeviz: this.idDeviz });
      if(response){
        return response.is_montaj_senzori;
      }
      return false;
    },

    selectObservatieHandler(newVal) {
      const selected = newVal;

      const previous = this.observatiiPredefiniteDetaliate.map(
        (o) => o.observatiePredefinita
      );

      const removed = previous.filter((obs) => !selected.includes(obs));

      removed.forEach((obsText) => {
        this.observatiiPredefiniteDetaliate =
          this.observatiiPredefiniteDetaliate.filter(
            (item) => item.observatiePredefinita !== obsText
          );
      });

      if (removed.length == 0) {
        const lastAdded = selected[selected.length - 1];
        const lastAddedFromDb = this.Info.Observatii.find(obs => obs.observatie === lastAdded);
        const acceptaCantitate = lastAddedFromDb ? lastAddedFromDb.accepta_cantitate : false;
        const cantitateMaxima = lastAddedFromDb ? lastAddedFromDb.cantitate_maxima : 0;

        this.$refs.observatii_devize.show_me(lastAdded, this.cantitate, acceptaCantitate, cantitateMaxima);
      }
    },
    saveObsDialog(payload) {
      const alreadyExists = this.observatiiPredefiniteDetaliate.some(
        (item) => item.observatiePredefinita === payload.observatiePredefinita
      );
      if (!alreadyExists) {
        this.observatiiPredefiniteDetaliate.push(payload);
      }
    },
    closeObsDialog(payload) {
      const alreadyExists = this.observatiiPredefiniteDetaliate.some(
        (item) => item.observatiePredefinita === payload.observatiePredefinita
      );
      if (!alreadyExists) {
        this.observatiiPredefiniteDetaliate.push(payload);
      }
    },
  },
  mounted: function () { },
};
</script>

<style lang="less" scoped>
.full-width {
  width: 100%;
}

.el-checkbox.is-bordered+.el-checkbox.is-bordered {
  margin-left: 0px !important;
}
</style>
